module.exports = __webpack_public_path__ + "static/media/15.1a4fa75d.jpg";